<template>
  <div id="waitStrongLeader">
    <v-card
      class="mx-auto"
      max-width="600"
      min-width="300"
      min-height="80"
      color="#f6f6fa"
    >
      <p style="color:#FFFFFF;background-color:#5555BB"><b>強力なリーダー</b></p>
      <div class="wait-decline-area">
        <div v-if="isExecuter">
        <!-- <div v-if="haveStrongLeader"> -->
          <!-- <div v-if="!sent"> -->
            <p><span v-on:click="showEffect(1)" class="plot-name"><b><u>強力なリーダー</u></b></span>を使用しますか．</p>
            <v-container fluid>
              <v-row justify="center">
                <div class="agree">
                  <agreeButton v-if="picked=='true'" label="する" active='true' />
                  <agreeButton v-else v-on:pushed="setPick('true')" label="する" active='false' />
                </div>
                <div class="disagree">
                  <disagreeButton v-if="picked=='false'" label="しない" active='true' />
                  <disagreeButton v-else v-on:pushed="setPick('false')" label="しない" active='false' />
                </div>
              </v-row>
            </v-container>
            <!-- <div v-if="picked=='true'">
              <v-btn class="agree" v-on:click="setPick('true')" large color="primary" min-width=120><b>使用する</b></v-btn>
              <v-btn class="disagree" v-on:click="setPick('false')" large color="primary" outlined max-width=120>使用しない</v-btn>
            </div>
            <div v-else-if="picked=='false'">
              <v-btn class="agree" v-on:click="setPick('true')" large color="primary" outlined min-width=120>使用する</v-btn>
              <v-btn class="disagree" v-on:click="setPick('false')" large color="primary" max-width=120><b>使用しない</b></v-btn>
            </div>
            <div v-else>
              <v-btn class="agree" v-on:click="setPick('true')" large color="primary" outlined min-width=120>使用する</v-btn>
              <v-btn class="disagree" v-on:click="setPick('false')" large color="primary" outlined max-width=120>使用しない</v-btn>
            </div> -->

            <div class="send-button">
              <sendButton v-if="picked=='true'||picked=='false'" v-on:pushed="push" label="決定" active="true"/>
              <sendButton v-else label="決定" active="false"/>
            </div>

          <!-- </div>
          <div v-else>
            <span>ゲーム情報を取得しています．</span>
          </div> -->
        </div>
        <div v-else>
          <p>{{ executer.name }}による<span v-on:click="showEffect(1)" class="plot-name"><b><u>強力なリーダー</u></b></span>の使用を待っています．</p>
        </div>
      </div>
    </v-card>
  </div>
</template>
<script>
import agreeButton from '@/components/gameUiComponents/AgreeButton.vue'
import disagreeButton from '@/components/gameUiComponents/DisagreeButton.vue'
import sendButton from '@/components/gameUiComponents/SendButton.vue'
export default {
  name: "waitStrongLeader",
  plops: [],
  components: {
    agreeButton,
    disagreeButton,
    sendButton
  },
  data() {
    return {
      socket: this.$store.state.webSocket.socket,
      roomId: this.$store.getters.roomId,
      userName: this.$store.getters.userName,
      userId: this.$store.getters.userId,
      picked: '',
      sent: false,
    };
  },
  computed: {
    users: function() {
      return this.$store.state.userList.users;
    },
    haveStrongLeader(){
      for (var i in this.users){
        if (this.users[i].id == this.userId){
          const plotCards = this.users[i].plots.filter(plot => plot.id == 1 && !plot.done)
          if (plotCards.length > 0){
            return true
          }
        }
      }
      return false
    },
    executerIndex (){
      return this.$store.state.plotData.plotExecuterIndex
    },
    executer () {
      var leaderIndex = 0;
      for (var i=0; i<this.users.length; i++){
        if(this.users[i].isLeader){
          leaderIndex = i;
          break
        }
      }
      var executer = []
      for (i=0; i<this.users.length; i++){
        // カードごとの処理
        // for (var j=0; j<this.users[(leaderIndex+i)%this.users.length].plots.filter(plot => plot.id == 1 && !plot.done).length; j++){
        //   executer.push(this.users[(leaderIndex+i)%this.users.length])
        // }

        // プレイヤごとの処理
        if(this.users[(leaderIndex+i)%this.users.length].plots.find(plot => plot.id == 1 && !plot.done)){
          executer.push(this.users[(leaderIndex+i)%this.users.length])
        }
      }
      return executer.length > this.executerIndex ? executer[this.executerIndex] : null
    },
    isExecuter() {
      return (this.executer.id == this.userId)
    }
  },
  methods: {
    setPick(pick) {
      this.picked = pick
    },
    push(){
      // var picked = false
      // if (this.picked == 'pick'){
      //   picked = true
      // }
      // this.sent = true
      console.log(this.picked)
      this.$emit("send-request", {"action": "decide-strong-leader", "roomId": this.roomId, "userId": this.userId, data: {"strong-leader": this.picked}})
      this.picked = ''
    },
    showEffect: function(id){
      var plot = this.$store.getters.getPlotEffect(id);
      var modalContent = {title: plot.name, text: plot.effect}
      this.$emit('send-modal', modalContent)
    },
  },
  created (){
    this.$store.commit('initExecuterIndex')
    var self = this
    this.socket.onmessage = function(event){
      console.log("Received")
      console.log(event)
      const res = JSON.parse(event.data)
      if (!res.state) {return}
      // "wait-spotlight" or "running-mission"
      var snackText = ""
      if (res.state != "wait-strong-leader"){
        snackText = ""
        // 使用判定
        if (res.data["strong-leader"] == "true"){
          snackText += self.executer.name + "は強力なリーダーを使用しました．"
          self.$store.commit('deletePlot', {'userId': self.executer.id, 'plotId': 1})
        }else {
          snackText += self.executer.name + "は強力なリーダーを使用しませんでした．"
        }

        snackText += "次のリーダーは"
        snackText += self.$store.getters.getUserById(res.data["next-leader"]).name
        snackText += "です．"
        self.$store.commit('setLeader', {userId: res.data['next-leader']})
        if (self.userId == res.data['next-leader']){
          self.$store.commit('beLeader')
        }else {
          self.$store.commit('beMember')
        }
        if (res.data.plots){
          if (res.data.plots.length > 0){
            for (var i in res.data.plots){
              if(i > 0){
                snackText += "，"
              }
              snackText += self.$store.getters.getPlotName(res.data.plots[i])
            }
            snackText += "を引きました．"
            self.$store.commit('addDrawnPlots', {'plots': res.data.plots})
          }
        }

        self.$emit("show-text", {state: "decide-strong-leader", text: snackText})
        console.log(res.state)
        var nextState = "checkingPlot"
        if (res.state == "checking-plot"){
          nextState = "checkingPlot"
        }else if (res.state == "assigning-mission"){
          nextState = "assigningMission"
        }

        self.$emit("proceed-state", nextState)
      }else {
        snackText = self.executer.name
        snackText += "は強力なリーダーを使用しませんでした．"
        self.$emit("show-text", {state: "decide-strong-leader"+self.executer.name, text: snackText})
        self.$store.commit('proceedExecuterIndex')
      }
    }
  }
}
</script>
<style>
#waitStrongLeader .send-button {
  padding-top: 12px;
  padding-bottom: 12px
}
#waitStrongLeader .agree {
  margin-right: 12px
}
#waitStrongLeader .plot-name {
  color: #5555BB;
  cursor:pointer;
}
</style>
